const I = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiPz4KPHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgODUuMzMzIDUxMyAzNDIiPgo8cmVjdCB5PSI4NS4zMzEiIGZpbGw9IiMyZDZlNDEiIHdpZHRoPSI1MTMiIGhlaWdodD0iMzQyIi8+CjxjaXJjbGUgZmlsbD0iI0Y0MEIzMiIgY3g9IjIxOC45MDIiIGN5PSIyNTYuNSIgcj0iMTE1Ii8+Cjwvc3ZnPgo=";
export {
  I as default
};
//# sourceMappingURL=BD-bee29685.mjs.map
